module.exports = __webpack_public_path__ + "static/dianne-eberhardt.24455aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dianne-eberhardt.png
// module id = 645
// module chunks = 169858455373905